module.exports = __webpack_public_path__ + "static/media/buggy.48e88061.svg";